import React from 'react';
import './navigationBar.less';

const NavigationBar = props => {
    const { anchor, currentIndex, total, changeIndex } = props;

    const handleItemClick = (index) => {
        changeIndex && changeIndex(index);
    }

    const getItems = () => {
        let items = [];
        const currentStyle = {
            opacity: 1
        }
        for(let i=1; i < total; ++i) {
            items.push((
                <div className='navigation_item' key={i} style={currentIndex == i ? currentStyle : undefined} onClick={() => handleItemClick(i)}>
                    <img src={`/assets/nav_${i}.png`} />
                </div>
            ))
        }
        return items;
    }

    return (
        <div className='navigation' >
            { !anchor.isMobile && getItems() }
        </div>
    )
}

export default NavigationBar;